import './ExploreRightSection.css';
import promoBanerExplore from '../../img/promo-banner-explore.svg';
import ProductSearchResults from '../ProductSearchResults/ProductSearchResults';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import localProductBanner from '../../img/local-product-img-banner.png';
import electronicProductBanner from '../../img/electronic-img-banner.png';
import sportProductBanner from '../../img/sports-img-banner.png';
import fashionProductBanner from '../../img/fashion-img-banner.png';
import propertyProductBanner from '../../img/properties-img-banner.png';
import othersProductBanner from '../../img/lainnya-img-banner.png';

const ExploreRightSection = () => {

    // parseInt(document.querySelector("#pages-1").innerHTML)

    let find = window.location.search;
    let params = new URLSearchParams(find);
    let searchQuery = params.get('search');
    let categoryQuery = params.get('category');
    console.log(searchQuery);
    console.log(categoryQuery);

    const [totalPages, setTotalPages] = useState(null);
    const [currentPages, setCurrentPages] = useState(1);
    const [productDetailsData, setProductDetailsData] = useState([]);
    const [categoryRequest, setCategoryRequest] = useState(categoryQuery);
    const [searchRequest, setSearchRequest] = useState(searchQuery);
    const [productLoading, setProductLoading] = useState(false);

    const handleCategoryChange = (e) => {
        console.log(e.target.innerHTML);
    }

    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    const fetchData = async () => {
        let response;
        if (categoryQuery === null) {
            let searchQuery = params.get('search');
            if (searchRequest != searchQuery) {
                setSearchRequest(categoryQuery);
            }
            response = await fetch("https://backend-markopedia.herokuapp.com/api/product/products?search=" + searchRequest + "&pageNum=" + currentPages, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                }
            }).then(res => res.json());
            setTotalPages(response.paging.totalPages);
            setProductDetailsData(response.data)
            setProductLoading(true);
            console.log(response);
        } else if (searchQuery === null) {
            let categoryQuery = params.get('category');
            if (categoryRequest != categoryQuery) {
                setCategoryRequest(categoryQuery);
                console.log(categoryRequest)
            }
            response = await fetch("https://backend-markopedia.herokuapp.com/api/product/products?category=" + categoryRequest + "&pageNum=" + currentPages, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                }
            }).then(res => res.json());
            setTotalPages(response.paging.totalPages);
            setProductDetailsData(response.data);
            setProductLoading(true);
            console.log(response);
        } else {
            let searchQuery = params.get('search');
            if (searchRequest != searchQuery) {
                setSearchRequest(categoryQuery);
                console.log(searchRequest);
            }

            let categoryQuery = params.get('category');
            if (categoryRequest != categoryQuery) {
                setCategoryRequest(categoryQuery);
                console.log(categoryRequest)
            }

            response = await fetch("https://backend-markopedia.herokuapp.com/api/product/products?category=" + categoryRequest + "&search=" + searchRequest + "&pageNum=" + currentPages, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                }
            }).then(res => res.json());
            setTotalPages(response.paging.totalPages);
            setProductDetailsData(response.data)
            setProductLoading(true);
            console.log(response);
        }
    }

    const testClickhandler = (e) => {
        console.log(e.target.innerHTML);
    }

    const handlePageNumber = (e) => {
        setCurrentPages(e.target.innerHTML);
        window.scrollTo({ top: 120, behavior: "smooth" });
    }

    const getProductBanner = (category) => {

        let bannerTitle;
        let bannerBody;
        let bannerImage;
        let bannerClass = "promoimage-container ";

        if (category == "localproduct") {
            bannerTitle = "Yogya Shoes For Running Men Sneakers";
            bannerBody = "Sepatu lokal kualitas tinggi yang sangat cocok untuk keseharian Anda";
            bannerImage = localProductBanner;
            bannerClass += "localproduct-blue";
        } else if (category == "electronic"){
            bannerTitle = "iPhone 12 Pro Max S Plus Ultra Maximum Quality";
            bannerBody = "Smartphone terbaik di dunia berada di genggaman Anda";
            bannerImage = electronicProductBanner;
            bannerClass += "electronic-red";
        } else if (category == "sport"){
            bannerTitle = "Bola Adidas Premium Soft Terbaik";
            bannerBody = "Bola dengan kualitas tinggi dan harga murah";
            bannerImage = sportProductBanner;
            bannerClass += "sport-green";
        } else if (category == "fashion"){
            bannerTitle = "Baju Santai Casual Premium Quality";
            bannerBody = "Fashion baju terbaru dengan kualitas ternama";
            bannerImage = fashionProductBanner;
            bannerClass += "fashion-green"
        } else if (category == "properties"){
            bannerTitle = "Meja Kayu Grand Furniture";
            bannerBody = "Meja yang nyaman untuk Anda";
            bannerImage = propertyProductBanner;
            bannerClass += "property-brown";
        } else {
            bannerTitle = "Bingkai Foto Kayu Lokal Kualitas Dunia";
            bannerBody = "Bingkai foto yang unik dan cantik untuk dipajang di rumah Anda";
            bannerImage = othersProductBanner;
            bannerClass += "others-purple";
        }

        return (
            <div className={bannerClass}>
                <div className="promoimage-leftsection">
                    <div className="promo-title-underlined">
                        <h4 className="promo-title-top">PROMO</h4>
                        <div className="promo-underline"></div>
                    </div>
                    <h3 className="promo-description-title">
                        {bannerTitle}
                    </h3>
                    <h5 className="promo-description-body">
                        {bannerBody}
                    </h5>
                </div>
                <div className="promoimage-rightsection">
                    <img src={bannerImage}></img>
                </div>
            </div>
        )
    }

    useEffect(() => {
        fetchData();
    }, [currentPages, searchQuery, categoryQuery]);

    return (
        <div className="explore-explorerightsection-wrapper">
            <div className="explore-explorerightsection-promoimage">
                {
                    getProductBanner(categoryQuery)
                }
            </div>
            <div className="explore-sortybywrapper">
                <span>Urutkan berdasarkan</span>
                <select>
                    <option value="name">Nama</option>
                    <option value="price">Harga</option>
                </select>
            </div>
            <div className="explore-productsearch-wrapper">
                <ProductSearchResults loading={productLoading} data={productDetailsData} />
            </div>
            {
                productDetailsData.length == 0 ?
                    null
                    :
                    <div onClick={testClickhandler} className="explore-pages">
                        {pageNumbers.map(number => {
                            return (
                                <div
                                    onClick={handlePageNumber}
                                    id={"pages-" + number}
                                    className={
                                        number == currentPages ? "page-active" : "page-inactive"
                                    }
                                >
                                    {number}
                                </div>
                            )
                        })}
                    </div>
            }
        </div>
    )
};

export default ExploreRightSection;